import {
    GatewayFilterRequestResponse,
} from 'app/requests/Gateway/Gateway.types'
import {
    injectFieldsToTabs, RangeType,
    SkyNetTableConfig, SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    AddressCategory,
    GatewayDataPlan,
    GatewayHardwareVersion,
    GatewayStatus,
    GatewayType,
} from 'app/enums/label.enums'
import {
    convertFromFilterDaysDate,
    convertToFilterDaysDate,
    parseFromFilterDaysDate,
    parseToFilterDaysDate,
} from 'app/utils/date'

const fields: SkyNetTableField<keyof GatewayFilterRequestResponse>[] = [
    {
        name: 'gatewayType',
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayType,
        filterField: 'gatewayType',
        filterType: FilterType.Array,
        reduced: true,
        width: '148px',
        labelKey: 'TYPE',
    },
    {
        name: 'gatewayImeiMac',
        width: '160px',
        labelKey: 'IMEI_MAC_ADDRESS',
    },
    {
        name: 'gatewayStatus',
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayStatus,
        filterField: 'gatewayStatus',
        filterType: FilterType.Array,
        width: '148px',
        labelKey: 'STATUS',
    },
    {
        name: 'lastStatusChangedOn',
        componentName: 'StatusAge',
        labelKey: 'STATUS_AGE',
        rangeType: RangeType.DayRange,
        filterField: 'lastStatusChangedOn',
        filterType: FilterType.IntegerRange,
        filterOptions: {
            labels: {
                from: 'More or Equal (Days)',
                to: 'Less Then (Days)',
            },
            convert: {
                from: convertFromFilterDaysDate,
                to: convertToFilterDaysDate,
            },
            parse: {
                from: parseFromFilterDaysDate,
                to: parseToFilterDaysDate,
            },
        },
        width: '148px',
    },
    {
        name: 'loggerConnections',
        width: '128px',
        labelKey: '#CONNECTIONS',
    },
    {
        name: 'isConnectedLora',
        componentName: 'CloudIconBoolean',
        filterField: 'isConnectedLora',
        filterType: FilterType.Array,
        width: '128px',
        labelKey: 'CONNECTED?',
    },
    {
        name: 'lastConnectedOn',
        componentName: 'TemperatureAge',
        width: '148px',
        labelKey: 'LAST_CONNECTION',
    },
    {
        name: 'locationLocationName',
        reduced: true,
        filterField: 'locationLocationName',
        width: '380px',
        filterType: FilterType.Array,
        labelKey: 'LOCATION',
    },
    {
        name: 'locationCountryName',
        filterField: 'locationCountryName',
        width: '180px',
        filterType: FilterType.Array,
        labelKey: 'LOCATION_COUNTRY',
    },
    {
        name: 'locationPortOfReferenceIataCode',
        filterField: 'locationPortOfReferenceIataCode',
        width: '180px',
        filterType: FilterType.Array,
        labelKey: 'PORT_OF_REFERENCE',
    },
    {
        name: 'gatewayLocationCategories',
        componentName: 'EnumList',
        allowedValuesEnum: AddressCategory,
        width: '320px',
        labelKey: 'CATEGORY',
    },
    {
        name: 'area',
        filterField: 'area',
        filterType: FilterType.Array,
        width: '160px',
        labelKey: 'AREA',
    },
    {
        name: 'gatewayDeploymentName',
        filterField: 'gatewayDeploymentName',
        filterType: FilterType.Array,
        width: '220px',
        labelKey: 'DEPLOYMENT_NAME',
    },
    {
        name: 'hardwareVersion',
        filterField: 'hardwareVersion',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayHardwareVersion,
        width: '180px',
        labelKey: 'HARDWARE_VERSION',
    },
    {
        name: 'gatewayConnectionType',
        filterField: 'gatewayConnectionType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: GatewayDataPlan,
        width: '180px',
        labelKey: 'CONNECTION_TYPE',
    },
    {
        name: 'remark',
        width: '380px',
        labelKey: 'REMARK',
    },
]

const config: SkyNetTableConfig<keyof GatewayFilterRequestResponse> = {
    name: 'GatewaysTable',
    tabs: injectFieldsToTabs<keyof GatewayFilterRequestResponse>([
        {
            name: 'Gateways',
            url: CommonRoutes.All,
        },
        {
            name: 'Excluded',
            url: CommonRoutes.Excluded,
        },
    ], fields),
}

export default config
